import React from 'react';
import './BurgerMenu.css';

function BurgerMenu({ isOpen, onClick }) {
  return (
    <div
      className={`burger-menu ${isOpen ? 'open' : ''}`}
      onClick={onClick}
      aria-label="Menu"
      role="button"
    >
      <div className="burger-menu-icon">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
}

export default BurgerMenu;